import React from 'react'
import styled from 'styled-components'
import RatingStar from "./RatingStar"

interface Props {
    rating: number
    size?: number
}

const BookRating: React.FC<Props> = ({rating, size}) => {
    return (
        <Container>
            {[1, 2, 3, 4, 5].map((i) => (
                <RatingStar key={i} isFilled={rating >= i} size={size ?? 50} />
            ))}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
`

export default BookRating
